/*
 * @Author: tangf tangf_86@163.com
 * @Date: 2024-03-26 13:52:11
 * @LastEditors: tangf tangf_86@163.com
 * @LastEditTime: 2024-04-16 20:29:45
 * @FilePath: \hippo-web-admin\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 主入口js */
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import '@/assets/style/font.scss'; // 文字库
import '@/assets/style/index.scss'; // 引入全局样式
import EleAdmin from 'ele-admin';
import en from 'ele-admin/packages/lang/en';
import 'amfe-flexible';
import versionCheckPlugin from './utils/versionCheckPlugin';

Vue.config.productionTip = false;
//引入多语言注册文件
import i18n from '@/lang/index';
import { getCurrentLang, setRtl } from '@/lang/index';

Vue.use(EleAdmin, {
  locale: en,
  request: {
    pageName: 'page',
    limitName: 'rows',
  },
  response: {
    dataName: 'rows',
    countName: 'total',
  },
});

Vue.use(versionCheckPlugin);

// 初始化时设置文档方向
const initLang = getCurrentLang();
setRtl(initLang);
// document.documentElement.dir = RTL_LANGUAGES.has(initLang) ? 'rtl' : 'ltr';
// document.documentElement.lang = initLang;

new Vue({
  router,
  store,
  i18n, //引入i18n
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
  render: (h) => h(App),
}).$mount('#app');
